module.exports = __webpack_public_path__ + "static/media/d11kz.12dac295.pdf";